import { useState } from "react";
import { MEDIA } from "../content/media";
import { COVER } from "../content/copy";

const useImage = (src) => {
  const [failed, setFailed] = useState(false);
  return [Boolean(src) && !failed, () => setFailed(true)];
};

export const BookCover = ({ className = "" }) => {
  const [show, onError] = useImage(MEDIA.bookCover);
  return (
    <div className={`book ${className}`} data-testid="book-cover-slot">
      {show ? (
        <img src={MEDIA.bookCover} alt={`${COVER.title} — ${COVER.author}`} onError={onError} className="book-img" />
      ) : (
        <div className="book-mock" aria-label={`${COVER.title} — ${COVER.author}`}>
          <span className="book-grid" aria-hidden="true" />
          <span className="book-author">{COVER.author}</span>
          <div>
            <span className="book-title">{COVER.title}</span>
            <span className="book-rule" aria-hidden="true" />
            <span className="book-sub">{COVER.subtitle}</span>
          </div>
          <span className="book-foot mono" aria-hidden="true">// 03:47:12</span>
        </div>
      )}
    </div>
  );
};

export const AuthorPhoto = () => {
  const [show, onError] = useImage(MEDIA.authorPhoto);
  return (
    <div className="author-photo" data-testid="author-photo-slot">
      {show ? (
        <img src={MEDIA.authorPhoto} alt="Salvatore Russolillo" onError={onError} />
      ) : (
        <div className="author-mono" aria-label="Salvatore Russolillo">
          <span>SR</span>
        </div>
      )}
    </div>
  );
};
